"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprintQuestionApi = exports.SprintQuestionApiFactory = exports.SprintQuestionApiFp = exports.SprintQuestionApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SprintQuestionApi - axios parameter creator
 * @export
 */
exports.SprintQuestionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Answer sprint question
         * @param {string} sprintQuestionId
         * @param {EditCreateSprintAnswer} [editCreateSprintAnswer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerSprintQuestion: (sprintQuestionId, editCreateSprintAnswer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sprintQuestionId' is not null or undefined
            common_1.assertParamExists('answerSprintQuestion', 'sprintQuestionId', sprintQuestionId);
            const localVarPath = `/sprintQuestion/{sprintQuestionId}/answer/`
                .replace(`{${"sprintQuestionId"}}`, encodeURIComponent(String(sprintQuestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editCreateSprintAnswer, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get sprint questions
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprintQuestions: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getSprintQuestions', 'id', id);
            const localVarPath = `/sprint/{id}/question/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SprintQuestionApi - functional programming interface
 * @export
 */
exports.SprintQuestionApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SprintQuestionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Answer sprint question
         * @param {string} sprintQuestionId
         * @param {EditCreateSprintAnswer} [editCreateSprintAnswer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerSprintQuestion(sprintQuestionId, editCreateSprintAnswer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.answerSprintQuestion(sprintQuestionId, editCreateSprintAnswer, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get sprint questions
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprintQuestions(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSprintQuestions(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SprintQuestionApi - factory interface
 * @export
 */
exports.SprintQuestionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SprintQuestionApiFp(configuration);
    return {
        /**
         *
         * @summary Answer sprint question
         * @param {string} sprintQuestionId
         * @param {EditCreateSprintAnswer} [editCreateSprintAnswer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerSprintQuestion(sprintQuestionId, editCreateSprintAnswer, options) {
            return localVarFp.answerSprintQuestion(sprintQuestionId, editCreateSprintAnswer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get sprint questions
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprintQuestions(id, options) {
            return localVarFp.getSprintQuestions(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SprintQuestionApi - object-oriented interface
 * @export
 * @class SprintQuestionApi
 * @extends {BaseAPI}
 */
class SprintQuestionApi extends base_1.BaseAPI {
    /**
     *
     * @summary Answer sprint question
     * @param {string} sprintQuestionId
     * @param {EditCreateSprintAnswer} [editCreateSprintAnswer]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprintQuestionApi
     */
    answerSprintQuestion(sprintQuestionId, editCreateSprintAnswer, options) {
        return exports.SprintQuestionApiFp(this.configuration).answerSprintQuestion(sprintQuestionId, editCreateSprintAnswer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get sprint questions
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprintQuestionApi
     */
    getSprintQuestions(id, options) {
        return exports.SprintQuestionApiFp(this.configuration).getSprintQuestions(id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SprintQuestionApi = SprintQuestionApi;
